<template>
  <div class="recharge_record" style="padding-bottom: 2rem">
    <navbar>
      <template #left>
        <!-- <span class="material-icons">chevron_left</span> -->
        <svg t="1748487155504" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
          p-id="21829" width=".6rem" height=".6rem">
          <path
            d="M637.5424 231.2192c22.8352 22.3232 24.6272 53.4016 0 80.6912l-191.8464 200.0896 191.8464 200.0896c24.6272 27.2896 22.8352 58.4192 0 80.5888-22.784 22.3232-61.2864 20.8896-82.688 0-21.4016-20.7872-230.5024-240.384-230.5024-240.384-11.4176-11.1104-17.152-25.7024-17.152-40.2944s5.7344-29.184 17.152-40.3968c0 0 209.1008-219.4944 230.5024-240.384s59.904-22.3232 82.688 0z"
            fill="#ffffff" p-id="21830"></path>
        </svg>
      </template>
      <template #title>
        <span style="color: #fff;font-size: .4267rem;">
          {{ $t('user.t6') }}
        </span>
      </template>
      <template #right>
        <!-- <span class="material-icons" @click="$router.push('/system_messages')">notifications_none</span> -->
        <svg @click="$router.push('/system_messages')" t="1748486708493" class="icon" viewBox="0 0 1024 1024"
          version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18639" width=".6rem" height=".6rem">
          <path
            d="M823.04 727.04L768 672v-213.333333c0-130.986667-69.973333-240.64-192-269.653334v-29.013333c0-35.413333-28.586667-64-64-64s-64 28.586667-64 64v29.013333C325.546667 218.026667 256 327.253333 256 458.666667v213.333333l-55.04 55.04c-26.88 26.88-8.106667 72.96 29.866667 72.96h561.92c38.4 0 57.173333-46.08 30.293333-72.96zM682.666667 714.666667H341.333333v-256c0-105.813333 64.426667-192 170.666667-192s170.666667 86.186667 170.666667 192v256z m-170.666667 213.333333c46.933333 0 85.333333-38.4 85.333333-85.333333h-170.666666a85.333333 85.333333 0 0 0 85.333333 85.333333z"
            p-id="18640" fill="#ffffff"></path>
        </svg>
      </template>
    </navbar>
    <div class="p">
      <div class="title">
        <span>{{ $t('user.t24') }}:</span>
        <span>${{ rechargeCount }}</span>
      </div>
      <div class="list">
        <van-list v-model="loading" :finished="finished" finished-text="NOT Data" @load="onLoad"
          loading-text="loading...">
          <div class="item" v-for="(item, index) in list" :key="index">
            <div class="l">
              <div class="code">
                {{ item.id }}
              </div>
              <div class="type" v-if="item.status == 1">
                {{ $t('user.t48') }}
              </div>
              <div class="type" v-if="item.status == 2">
                {{ $t('user.t47') }}
              </div>
              <div class="type" v-if="item.status == 3">
                {{ $t('user.t58') }}
              </div>
            </div>
            <div class="r">
              ${{ item.num }}
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      rechargeCount: 0,
      page: 1
    }
  },
  created() {
  },
  methods: {
    getRechargeList() {
      this.$http.setRechargeAdmin({
        page: this.page
      }).then(res => {
        if (res.info == 'ok') {
          this.list.push(...res.data);
          this.page++
          this.rechargeCount = res.rechagreCount
          this.loading = false
          if (this.list.length >= res.count) {
            this.finished = true;
          }
        }
      })
    },
    onLoad() {
      this.getRechargeList()
      console.log(this.list);

    }
  }
}
</script>

<style lang="less" scoped>
.recharge_record {
  .material-icons {}

  span {}

  .p {
    padding: 0 .4rem;

    .title {
      margin-top: .4rem;
      color: #fff;

      span {}
    }

    .list {
      .item {
        padding: .4rem 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .l {
          .code {
            color: #fff;
            font-weight: 400;
            margin-bottom: .1067rem;
            font-size: .3733rem;
          }

          .type {
            color: #fff;
            font-size: .2667rem;
            background-color: #1E88FF;
            padding: 0 .2667rem;
            border-radius: .8rem;
            width: fit-content;
          }
        }

        .r {
          color: #00BE7D;
        }
      }
    }
  }
}
</style>
